<script>
  export default {
    props: {
      customClass: {
        type: String,
        default: 'fill-primary',
      },
      disableHover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<template>
  <svg
    :class="[customClass, { 'no-hover': disableHover }]"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M28.599 9.9444H1.39631C0.0135208 9.9444 -0.0567906 10.686 0.0213332 11.5968L1.03694 26.3475C1.10725 27.2503 1.31038 28 2.68535 28H27.3881C28.7943 28 28.9584 27.2584 29.0365 26.3475L29.9818 11.4114C30.0521 10.5086 29.9818 9.9444 28.599 9.9444Z"/>
    <path d="M28.5093 6.28558C28.4696 5.4248 28.1519 5.22349 27.3101 5.22349C27.3101 5.22349 17.6685 5.22349 15.9372 5.22349C14.2058 5.22349 13.9993 5.24431 12.6889 4.01561C11.6008 2.98822 12.0297 3.0021 9.78214 3.0021C7.98725 3.0021 3.80183 3.0021 3.80183 3.0021C2.41993 3.0021 1.92753 2.89798 1.80046 4.15445C1.68133 5.31373 1.40336 8.12516 1.36365 8.55556H28.6364L28.5093 6.28558Z"/>
  </svg>
</template>
